var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object',{attrs:{"data":_vm.Constants.ServerUrl + '/service/devize/deviz_produse/' + _vm.IdDeviz,"type":"application/pdf","width":"100%","height":_vm.parentHeight}})}
var staticRenderFns = []

export { render, staticRenderFns }